export const BASE_PATH_TO_GAME = "/games";

// ==============================|| GAMES ||============================== //

export const BASE_PATH_TO_GAMES_LIST = `${BASE_PATH_TO_GAME}/game-levels`;
export const BASE_PATH_TO_ADD_GAMES = `${BASE_PATH_TO_GAME}/add-game-levels`;
export const BASE_PATH_TO_UPDATE_GAMES = `${BASE_PATH_TO_GAME}/update-game-levels`;